export default "__VITE_ASSET__KP2xtVeE__"